import { IndexedRules } from './IndexedRules.js';
export class CompatibilityFilter {
    constructor(model, compatibilityService) {
        this.model = model;
        this.compatibilityService = compatibilityService;
        this.indexedRulesByOptionPath = new Map();
        this.createIndexes();
    }
    match(propertyPath, option) {
        var _a;
        const values = (_a = this.indexedRulesByOptionPath.get(propertyPath)) !== null && _a !== void 0 ? _a : [];
        const len = values.length;
        let i = 0;
        for (; i < len; i++) {
            const value = values[i];
            const optionHash = value.optionSelectors.get(propertyPath)(option);
            const result = value.matchOne(propertyPath, optionHash);
            if (!result) {
                return false;
            }
        }
        return true;
    }
    filter(propertyPath, options) {
        const result = [];
        for (let option of options) {
            if (this.match(propertyPath, option)) {
                result.push(option);
            }
        }
        return result;
    }
    applyOption(propertyPath, option) {
        var _a;
        this.resetOption(propertyPath);
        const indexedRulesGroup = (_a = this.indexedRulesByOptionPath.get(propertyPath)) !== null && _a !== void 0 ? _a : [];
        for (let indexedRules of indexedRulesGroup) {
            const optionHash = indexedRules.optionSelectors.get(propertyPath)(option);
            indexedRules.applyFilter(propertyPath, optionHash);
        }
    }
    resetOption(propertyPath) {
        var _a;
        const indexedRulesGroup = (_a = this.indexedRulesByOptionPath.get(propertyPath)) !== null && _a !== void 0 ? _a : [];
        for (let indexedRules of indexedRulesGroup) {
            indexedRules.resetFilter(propertyPath);
        }
    }
    createIndexes() {
        for (const [tableName, table] of this.compatibilityService.tables) {
            if (!table.isCompatibilitySwitchedOff(this.model)) {
                this.createIndexFor(tableName, table);
            }
        }
    }
    createIndexFor(tableName, table) {
        const indexedRules = new IndexedRules(table);
        const optionPaths = indexedRules.involvedOptionPaths;
        for (let path of optionPaths) {
            let indexedRulesGroup = this.indexedRulesByOptionPath.get(path);
            if (!indexedRulesGroup) {
                indexedRulesGroup = [];
                this.indexedRulesByOptionPath.set(path, indexedRulesGroup);
            }
            indexedRulesGroup.push(indexedRules);
        }
    }
    anyMath(optionPath) {
        var _a;
        const indexedRulesGroup = (_a = this.indexedRulesByOptionPath.get(optionPath)) !== null && _a !== void 0 ? _a : [];
        return indexedRulesGroup.every(indexedRules => indexedRules.anyMatch());
    }
    resetAll() {
        for (const indexedRules of this.indexedRulesByOptionPath.values()) {
            for (const indexedRule of indexedRules) {
                indexedRule.resetAll();
            }
        }
    }
}
//# sourceMappingURL=CompatibilityFilter.js.map